import React from 'react';
import QRCode from 'react-qr-code';
import backVector from '../../../assets/img/back-vector.svg';

const Content = ({ card }) => {
  return (
    <div className="relative overflow-hidden h-full">
      <div className="flex flex-col gap-2 card items-center justify-center h-full">
        <div className="flex flex-col items-center justify-center gap-2">
          {card.signature && (
            <>
              <QRCode value={card.signature} size={80} />
              <div
                className="rounded-full text-white p-2"
                style={{ backgroundColor: '#00648D', fontSize: 9 }}
              >
                {card.signature}
              </div>
            </>
          )}
        </div>

        {card.code && (
          <div className="flex gap-2">
            <div
              className="w-10 text-center text-white font-medium py-1"
              style={{ backgroundColor: '#F29066' }}
            >
              {card.code.slice(0, 3)}
            </div>
            <div
              className="w-10 text-center text-white font-medium py-1"
              style={{ backgroundColor: '#47BABD' }}
            >
              {card.code.slice(3, 7)}
            </div>
          </div>
        )}
      </div>

      <img
        alt="background"
        src={backVector}
        className=" h-full absolute -left-12 -bottom-5 scale-125 transform"
      />
    </div>
  );
};

export default Content;
